import { isNullOrEmpty } from '@egr/wcf/modules/utils/string';

export function uint8ArrayToString(data: Uint8Array): string {
    let value: string = '';

    // Note: a loop is used instead of `String.fromCharCode.apply` to
    // avoid `Maximum call stack size` exceptions
    for (let i: number = 0, l: number = data.length; i < l; i++) {
        value += String.fromCharCode(data[i]);
    }

    return value;
}

export function base64ToUint8Array(data: string): Uint8Array {
    if (isNullOrEmpty(data)) {
        return new Uint8Array(0);
    }

    const byteStr: string = atob(data);
    const len: number = byteStr.length;
    const bytes: Uint8Array = new Uint8Array(len);
    for (let i: number = 0; i < len; i++) {
        bytes[i] = byteStr.charCodeAt(i);
    }

    return bytes;
}